import { render, staticRenderFns } from "./ModalOrderPaid.vue?vue&type=template&id=70d53e78&"
import script from "./ModalOrderPaid.vue?vue&type=script&lang=js&"
export * from "./ModalOrderPaid.vue?vue&type=script&lang=js&"
import style0 from "./ModalOrderPaid.vue?vue&type=style&index=0&id=70d53e78&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports